import { useEffect } from 'react';
import type { RefObject } from 'react';

export function useClickOutside(
    ref: RefObject<HTMLElement>,
    onOutside: () => void,
    enabled = true,
): void {
    useEffect(() => {
        if (!enabled) return;
        const onMouseDown = (e: MouseEvent): void => {
            if (ref.current && !e.composedPath().includes(ref.current))
                onOutside();
        };
        document.addEventListener('mousedown', onMouseDown);
        return () => {
            document.removeEventListener('mousedown', onMouseDown);
        };
    }, [ref, onOutside, enabled]);
}
